import { cn } from "@/lib/helpers/cn";
import { RadioGroup2 } from "@/ui2/molecules/RadioGroup";
import type { RadioGroup2Props } from "@/ui2/molecules/RadioGroup";

import { QuestionIndex } from "./QuestionIndex";

type FieldsetRatingProps = {
  questionNumber?: string;
} & RadioGroup2Props;

export function FieldsetRating({
  className,
  questionNumber,
  ...radioGroupProps
}: FieldsetRatingProps) {
  return (
    <>
      <QuestionIndex questionNumber={questionNumber} />
      <RadioGroup2
        classNameChildren={cn(
          "tw:grid tw:w-full tw:grid-flow-col tw:max-md:gap-0 tw:md:gap-2",
          className,
        )}
        {...radioGroupProps}
      />
    </>
  );
}
